export const TEST_NET = 'TEST_NET'
export const MAIN_NET = 'MAIN_NET'


// WEBPACK FOOTER //
// ./src/common/consts.js